import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: $localize`Quick Start`,
    icon: 'flash-outline',
    link: '/quick-start',
    pathMatch: 'full',
    home: true
  },
  {
    title: $localize`Insights`,
    icon: 'bulb-outline',
    link: '/insights',
    pathMatch: 'full'
  },
  {
    title: $localize`Campaigns`,
    icon: 'trending-up',
    children: [
      {
        title: $localize`Campaigns Analytics`,
        link: '/campaigns/analytics/deliveries',
        pathMatch: 'full'
      },
      {
        title: $localize`Manage Campaigns`,
        link: '/campaigns/table',
        pathMatch: 'full'
      }
    ]
  },
  {
    title: $localize`Content`,
    icon: 'file-text-outline',
    link: '/content/table',
    pathMatch: 'full'
  },
  {
    title: $localize`QA Tools`,
    icon: 'hard-drive-outline',
    children: [
      {
        title: $localize`Clean Score`,
        children: [
          {
            title: $localize`Create/Edit`,
            link: '/qa-testing/clean-score/create',
            pathMatch: 'full'
          },
          {
            title: $localize`View`,
            link: '/qa-testing/clean-score/view',
            pathMatch: 'full'
          }
        ]
      },
      {
        title: $localize`Cleaning Time Estimates`,
        link: '/qa-testing/cleaning-estimates',
        pathMatch: 'full'
      },
      {
        title: $localize`My Robots`,
        link: '/qa-testing/my-robots',
        pathMatch: 'full'
      },
      {
        title: $localize`QA Notification Tests`,
        link: '/qa-testing/qa-tool',
        pathMatch: 'full'
      },
      {
        title: $localize`Robot Part Health`,
        link: '/qa-testing/robot-part-health',
        pathMatch: 'full'
      }
    ]
  },
  {
    title: $localize`Surveys`,
    icon: 'checkmark-circle-outline',
    link: '/surveys',
    pathMatch: 'full'
  },
  {
    title: $localize`Robot Family Metadata`,
    icon: 'pricetags-outline',
    link: '/robot-family-metadata/table',
    pathMatch: 'full'
  },
  {
    title: $localize`DRBs`,
    icon: 'briefcase-outline',
    children: []
  }
];
